import './App.css';
import "antd/dist/antd.min.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React, { useEffect } from 'react';
import ReactGA from "react-ga4";
import { APINET } from './APINET';

const TRACKING_ID = "G-1BX9NHBTNZ";
ReactGA.initialize(TRACKING_ID);

function App() {
  useEffect(() => {
    ReactGA.send("pageview");
  }, []);

  return (
    <div className="App">
      <APINET />
    </div>
  );
}

export default App;